// iInvest - SPUL
// iWealthy - RPUL
// iLink - RPUDR

export const URL_OPEN_VIDEO = {
  RPUL: 'https://youtu.be/eDslvjpvAuk',
  SPUL: 'https://youtu.be/EKXlVc_84tQ',
  RPUDR: 'https://youtu.be/4abaV9ZqFNk',
}

export const URL_DOWNLOAD_PDF = {
  RPUL: 'https://ktaxa.live/SalesSheetforiWealthy',
  SPUL: 'https://ktaxa.live/SalesSheetforiInvest',
  RPUDR: 'https://ktaxa.live/SalesSheetiLink',
}
